// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body::after {
  content: url('N.svg') url('individus.png') url('individus_hover.png') url('individus_selected.png') url('analyse.png') url('analyse_hover.png') url('analyse_selected.png') url('postes.png') url('postes_hover.png') url('postes_selected.png') url('archives.png') url('archives_hover.png') url('archives_selected.png') url('admin.png') url('admin_hover.png') url('admin_selected.png') url('compte.png') url('compte_hover.png') url('tools.png') url('tools_selected.png') url('tools_hover.png');
}

.main_column {
  width: 100px;
  height: 100vh;
  overflow-y: auto;
  height: 100%;
  float: left;
  position: fixed;
}

.selectedButton {
  background-color: rgb(87, 87, 87);
}

.selectedText {
  color: white;
}

.enNews {
  padding-left: 11px;
}

.langue_icon,
.main_column_icon {
  display: none;
}

li.ngenioMenuButton {
  margin-bottom: 8px;
}

#dropUpSupport {
  padding: 25px;
}

#dropUpSupport li {
  height: 25px;
}

#dropUpSupport li span, #dropUpSupport li a span {
  cursor: pointer;
}

#dropUpSupport li span:hover, #dropUpSupport li a span:hover {
  color: #888;
}

.docLink {
  padding: 0;
  color: #111111;
}

@media (max-height: 799px) and (min-height: 1px) {
  .mbSatellite {
    margin-bottom: -182px;
  }
  .mbNormal {
    margin-top: 140% !important;
  }
}
@media (min-height: 800px) {
  .mbSatellite {
    margin-bottom: -142px;
  }
  .mbNormal {
    margin-bottom: -115px;
  }
}
.credits {
  background-color: darkgreen;
}

.creditsWarning {
  background-color: darkred;
}

.displayAccountInfo {
  display: none;
}

#connectedToDiv {
  white-space: nowrap;
  padding: 2px 3px;
  position: absolute;
  top: 7px;
  background: #6a6a6a;
  color: #EDF2F5;
  border-radius: 3px;
  max-width: 360px;
  text-overflow: ellipsis;
}

/**

:host ::ng-deep .tooltip {
    text-align: left;

}

:host ::ng-deep .tooltip-inner {
    text-align: left;
    background-color: #333;
    max-width: 1000px;
}

:host ::ng-deep .tooltip.top .tooltip-arrow:before,
:host ::ng-deep .tooltip.top .tooltip-arrow {
    border-top-color: #333;
}**/
/**
@media (max-width: 767px) {
    .main_column {
        width: 0;
        display: none;
    }

    .main_column_icon {
        display: block;
    }
}

@media (min-width: 768px) and (max-width: 991px) {
    #leftMenu ul {
        margin-top: 26px;
    }

    #leftMenu ul li.firstItem {
        margin-top: 26px;
    }

    .main_column {
        width: 50px;
    }

    #leftMenu {
        width: 50px;
        background-image: url('../../../../assets/menu_gauche/colonne_background.png');
        height: 100%
    }

    li.ngenioMenuButton a img {
        width: 50px;
    }

    .mainMenuButtonTitle,
    .mainMenuItemTextLine2,
    .mainMenuItemTextLeft,
    .column_mode_off {
        display: none
    }

    .ngenioMenuButton,
    .mainMenuButton,
    .mainMenuItemContainer,
    .mainMenuButtonBottom,
    .mainButtonSelected,
    .mainButtonSelected a {
        width: 50px;
        height: 50px
    }

    .langue_icon {
        width: 40px;
        display: block
    }

    .account_icon {
        margin-top: 11px
    }

    .langue_icon, .quitter_icon {
        margin-top: 4px;
    }
}
*/`, "",{"version":3,"sources":["webpack://./src/app/app/components/navigation/navigation.component.scss"],"names":[],"mappings":"AAAA;EACI,yeACI;AAAR;;AAuBA;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AApBJ;;AAuBA;EACI,iCAAA;AApBJ;;AAuBA;EACI,YAAA;AApBJ;;AAuBA;EACI,kBAAA;AApBJ;;AAuBA;;EAEI,aAAA;AApBJ;;AAuBA;EACI,kBAAA;AApBJ;;AAuBA;EACI,aAAA;AApBJ;;AAuBA;EACI,YAAA;AApBJ;;AAuBA;EACI,eAAA;AApBJ;;AAuBA;EACI,WAAA;AApBJ;;AAuBA;EACI,UAAA;EACA,cAAA;AApBJ;;AAuBA;EACI;IACI,qBAAA;EApBN;EAsBE;IACI,2BAAA;EApBN;AACF;AAuBA;EACI;IACI,qBAAA;EArBN;EAuBE;IACI,qBAAA;EArBN;AACF;AA0BA;EACI,2BAAA;AAxBJ;;AA2BA;EACI,yBAAA;AAxBJ;;AA2BA;EACI,aAAA;AAxBJ;;AA2BA;EACI,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAxBJ;;AA2BA;;;;;;;;;;;;;;;;GAAA;AAkBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAAA","sourcesContent":["body::after {\n    content:\n        url(../../../../assets/menu_gauche/N.svg)\n        url(../../../../assets/menu_gauche/menu_principal/individus.png)\n        url(../../../../assets/menu_gauche/menu_principal/individus_hover.png)\n        url(../../../../assets/menu_gauche/menu_principal/individus_selected.png)\n        url(../../../../assets/menu_gauche/menu_principal/analyse.png)\n        url(../../../../assets/menu_gauche/menu_principal/analyse_hover.png)\n        url(../../../../assets/menu_gauche/menu_principal/analyse_selected.png)\n        url(../../../../assets/menu_gauche/menu_principal/postes.png)\n        url(../../../../assets/menu_gauche/menu_principal/postes_hover.png)\n        url(../../../../assets/menu_gauche/menu_principal/postes_selected.png)\n        url(../../../../assets/menu_gauche/menu_principal/archives.png)\n        url(../../../../assets/menu_gauche/menu_principal/archives_hover.png)\n        url(../../../../assets/menu_gauche/menu_principal/archives_selected.png)\n        url(../../../../assets/menu_gauche/menu_principal/admin.png)\n        url(../../../../assets/menu_gauche/menu_principal/admin_hover.png)\n        url(../../../../assets/menu_gauche/menu_principal/admin_selected.png)\n        url(../../../../assets/menu_gauche/menu_principal/compte.png)\n        url(../../../../assets/menu_gauche/menu_principal/compte_hover.png)\n        url(../../../../assets/menu_gauche/menu_principal/tools.png)\n        url(../../../../assets/menu_gauche/menu_principal/tools_selected.png)\n        url(../../../../assets/menu_gauche/menu_principal/tools_hover.png);\n}\n\n.main_column {\n    width: 100px;\n    height: 100vh;\n    overflow-y: auto;\n    height: 100%;\n    float: left;\n    position: fixed;\n}\n\n.selectedButton {\n    background-color: rgb(87, 87, 87);\n}\n\n.selectedText {\n    color: white;\n}\n\n.enNews {\n    padding-left: 11px;\n}\n\n.langue_icon,\n.main_column_icon {\n    display: none;\n}\n\nli.ngenioMenuButton {\n    margin-bottom: 8px;\n}\n\n#dropUpSupport {\n    padding: 25px;\n}\n\n#dropUpSupport li {\n    height: 25px;\n}\n\n#dropUpSupport li span, #dropUpSupport li a span {\n    cursor: pointer;\n}\n\n#dropUpSupport li span:hover, #dropUpSupport li a span:hover {\n    color: #888;\n}\n\n.docLink {\n    padding: 0;\n    color: #111111;\n}\n\n@media (max-height: 799px) and (min-height: 1px) {\n    .mbSatellite {\n        margin-bottom: -182px;\n    }\n    .mbNormal {\n        margin-top: 140% !important;\n    }\n}\n\n@media (min-height: 800px) {\n    .mbSatellite {\n        margin-bottom: -142px;\n    }\n    .mbNormal {\n        margin-bottom: -115px;\n    }\n}\n\n\n\n.credits {\n    background-color: darkgreen;\n}\n\n.creditsWarning {\n    background-color: darkred;\n}\n\n.displayAccountInfo {\n    display: none\n}\n\n#connectedToDiv {\n    white-space: nowrap;\n    padding: 2px 3px;\n    position: absolute;\n    top: 7px;\n    background: #6a6a6a;\n    color: #EDF2F5;\n    border-radius: 3px;\n    max-width: 360px;\n    text-overflow: ellipsis;\n}\n\n/**\n\n:host ::ng-deep .tooltip {\n    text-align: left;\n\n}\n\n:host ::ng-deep .tooltip-inner {\n    text-align: left;\n    background-color: #333;\n    max-width: 1000px;\n}\n\n:host ::ng-deep .tooltip.top .tooltip-arrow:before,\n:host ::ng-deep .tooltip.top .tooltip-arrow {\n    border-top-color: #333;\n}**/\n\n/**\n@media (max-width: 767px) {\n    .main_column {\n        width: 0;\n        display: none;\n    }\n\n    .main_column_icon {\n        display: block;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n    #leftMenu ul {\n        margin-top: 26px;\n    }\n\n    #leftMenu ul li.firstItem {\n        margin-top: 26px;\n    }\n\n    .main_column {\n        width: 50px;\n    }\n\n    #leftMenu {\n        width: 50px;\n        background-image: url('../../../../assets/menu_gauche/colonne_background.png');\n        height: 100%\n    }\n\n    li.ngenioMenuButton a img {\n        width: 50px;\n    }\n\n    .mainMenuButtonTitle,\n    .mainMenuItemTextLine2,\n    .mainMenuItemTextLeft,\n    .column_mode_off {\n        display: none\n    }\n\n    .ngenioMenuButton,\n    .mainMenuButton,\n    .mainMenuItemContainer,\n    .mainMenuButtonBottom,\n    .mainButtonSelected,\n    .mainButtonSelected a {\n        width: 50px;\n        height: 50px\n    }\n\n    .langue_icon {\n        width: 40px;\n        display: block\n    }\n\n    .account_icon {\n        margin-top: 11px\n    }\n\n    .langue_icon, .quitter_icon {\n        margin-top: 4px;\n    }\n}\n*/\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
